import convert from 'xml-js';
import { clone } from 'lodash';
import { withBasePath } from '_config/basePath';

interface UsedFields {
  generic: Set<string>;
  [key: string]: Set<string>;
}

interface Element {
  name?: string;
  attributes?: {
    type?: string;
    match?: string;
    variable?: string;
  };
  elements?: Element[];
}

export const iterateMacros = (elements: Element[] | undefined, types: string[], fields: UsedFields): void => {
  if (!elements) return;
  
  const currentTypes = clone(types);
  
  for (const element of elements) {
    const attributes = element.attributes || {};
    
    if (["if", "else-if"].includes(element.name || '') && 
        attributes.type && 
        ["any", undefined].includes(attributes.match)) {
      iterateMacros(
        element.elements, 
        currentTypes.concat(attributes.type.split(" ")), 
        fields
      );
      continue;
    }
    
    if (attributes.variable && !attributes.variable.includes(" ")) {
      if (currentTypes.length === 0) {
        fields.generic.add(attributes.variable);
      }
      
      for (const type of currentTypes) {
        if (!(type in fields)) {
          fields[type] = new Set<string>();
        }
        fields[type].add(attributes.variable);
      }
    }
    
    iterateMacros(element.elements, currentTypes, fields);
  }
};

export const getUsedFields = async (style: string): Promise<UsedFields> => {
  try {
    const response = await fetch(withBasePath(`/citations/${style}.csl`));
    if (!response.ok) {
      throw new Error(`Failed to fetch style: ${response.statusText}`);
    }
    
    const styleText = await response.text();
    const styleJson = JSON.parse(convert.xml2json(styleText, { 
      compact: false, 
      spaces: 4 
    }));
    
    const usedFields: UsedFields = { generic: new Set<string>() };
    const macros = styleJson.elements[0].elements.filter(
      (element: Element) => element.name === "macro"
    );
    
    iterateMacros(macros, [], usedFields);
    return usedFields;
  } catch (error: unknown) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    throw new Error(`Error processing citation fields: ${errorMessage}`);
  }
};